import React, { Component } from "react";
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import { Card } from "semantic-ui-react";
import Subscription from "~/models/Subscription/Subscription";
import ProviderStatistic from "~/models/Provider/ProviderStatistic";
import CustomerStatistic from "~/models/Customer/CustomerStatistic";
import ContentLoader from "~/components/element/ContentLoader";
import UiMeet3dSubscriptionStatisticGroup from "~/modules/UiMeet3d/components/UiMeet3dSubscriptionStatisticGroup";
import "../styles/CustomerHasUrbanimmersiveSpecialPricingCard.less";

@observer
class CustomerHasUrbanimmersiveSpecialPricingCard extends Component {
  getCardDescription(isLoading, subscription, statistic) {
    if (isLoading) {
      return <ContentLoader />;
    }

    if (!subscription) {
      return <p>No subscription</p>;
    }

    return (
      <UiMeet3dSubscriptionStatisticGroup
        subscription={subscription}
        statistic={statistic}
        statisticModule="activeToursCount"
        showMinutes={false}
        showLeads={false}
        showNotifications={false}
      />
    );
  }

  render() {
    const { isLoading, subscription, statistic } = this.props;

    return (
      <Card fluid className="customer-has-urbanimmersive-special-pricing">
        <Card.Content>
          <Card.Header>Customer has special pricing</Card.Header>
          <Card.Description>{this.getCardDescription(isLoading, subscription, statistic)}</Card.Description>
        </Card.Content>
      </Card>
    );
  }
}

CustomerHasUrbanimmersiveSpecialPricingCard.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  subscription: PropTypes.instanceOf(Subscription),
  statistic: PropTypes.oneOfType([PropTypes.instanceOf(ProviderStatistic), PropTypes.instanceOf(CustomerStatistic)]),
};

export default CustomerHasUrbanimmersiveSpecialPricingCard;
